import upperFirst from "utils/upper_first";

export default function getLogType({type}) {
  return upperFirst((type || "").toLowerCase().replace(/_/g, " "));
}
